import { notifications } from "@mantine/notifications";

export const sendError = (message: string, id?: string) =>
  notifications.show({
    id: id || message,
    message,
    title: "Ошибка",
    color: "red",
  });
